import { Grid, IconButton, Typography } from '@mui/material';
import { arrowBack } from '../../assets/icons/icons';
import { useAuth } from '../../hooks/useAuth';
import { getTheme } from '../../stores/selectors/theme.selector';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ZendeskChatHeaderIcon } from '../zendesk/zendesk-chat-header-icon.component';
import { headerStyles } from './header-styles';

interface BackButtonHeaderProps {
  title?: string;
  subTitle?: string;
  icon?: React.ReactNode;
  onIconClicked?: () => void;
  onBackArrowClicked: () => void;
  onZendeskChatClicked?: () => void;
  companyIcon?: React.ReactNode;
  isReceipt?: boolean;
  isSpaceBetweenAlign?: boolean;
  dataTestId?: string;
}

export const BackButtonHeader = ({
  title,
  subTitle,
  onBackArrowClicked,
  onIconClicked,
  onZendeskChatClicked,
  icon,
  companyIcon,
  isReceipt,
  isSpaceBetweenAlign,
  dataTestId,
}: BackButtonHeaderProps) => {
  const classes = headerStyles();
  const auth = useAuth();
  const { i18n } = useTranslation();

  const theme = useSelector(getTheme);
  return (
    <Grid
      container
      direction='row'
      justifyContent={onBackArrowClicked && !isSpaceBetweenAlign ? 'flex-start' : 'space-between'}
      alignItems='center'
      className={classes.header}
      style={{
        height: '60px',
        backgroundColor: '#fff',
      }}
      padding={companyIcon || isReceipt ? '0px 24px' : '0px 16px '}
    >
      <Grid item>
        <IconButton
          onClick={() => onBackArrowClicked()}
          style={{ padding: 0, backgroundColor: 'transparent' }}
          aria-label={String(i18n.t('back_to_previous_page'))}
        >
          {arrowBack(theme.primary)}
        </IconButton>
      </Grid>

      <Grid item paddingLeft={'16px'}>
        <Typography variant='h4' className={classes.title} data-testid={dataTestId}>
          {title}
        </Typography>
        {subTitle && <Typography className={classes.subTitle}>{subTitle}</Typography>}
      </Grid>

      {companyIcon && <Grid>{companyIcon}</Grid>}

      {(onZendeskChatClicked || icon) && (
        <Grid item className={classes.rightIconsContainer}>
          {onZendeskChatClicked && (
            <IconButton
              className={classes.accountIcon}
              onClick={() => onZendeskChatClicked()}
              aria-label={String(i18n.t('open_chat') || 'Open chat')}
            >
              <ZendeskChatHeaderIcon />
            </IconButton>
          )}
          {icon && (
            <IconButton
              className={classes.accountIcon}
              onClick={() => onIconClicked?.()}
              aria-label={auth.isLoggedIn ? String(i18n.t('go_to_my_account')) : ''}
            >
              {icon}
            </IconButton>
          )}
        </Grid>
      )}
    </Grid>
  );
};
